import { computed, observable, makeObservable } from "mobx"
import { RootStore } from "stores/root.store"
import {
  createTransactionBuffPlay,
  getGameCategoryOrder, getGamePlatforms, updateGameCategory,
} from "../api/game-category-order.call"
import { PaginationStore } from "../../../stores/data/pagination.store"

export interface GameCategoryOrderBaseType {
  name: string,
  categories: {
    name: string,
    platformIds: string[]
  }[],
}

export interface GameCategoryOrderType extends GameCategoryOrderBaseType {
  id: string
  isActive: boolean
}

export class GameCategoryOrderStore extends PaginationStore<GameCategoryOrderType> {
  @observable
  private _games: GameCategoryOrderType[] = []
  @observable
  private _selectedElement: GameCategoryOrderType = {} as GameCategoryOrderType
  @observable
  public isEmptyArr: boolean = false
  @observable
  public _platformIds: any[] = []

  constructor(rootStore: RootStore) {
    super(rootStore)
    makeObservable(this)
  }

  public async getData() {
    this.isEmptyArr = false

    return this.getGames()
  }

  public async getGames() {
    this.isLoading = true
    const games = await getGameCategoryOrder()
    if (games) {
      this._games = games
      this.isLoading = false
    }
    this.isLoading = false


    return games
  }

  public async createTransactionBuffPlay(values: GameCategoryOrderBaseType) {
    await this.defaultFunction(createTransactionBuffPlay, values)
  }

  public async updateGame(values: GameCategoryOrderType) {
    this.isLoading = true
    await this.defaultFunction(updateGameCategory, values)
  }

  public async getGamePlatforms() {
    const platforms = await getGamePlatforms()
    if (platforms) {
      this._platformIds = platforms.data
    }
  }

  @computed
  get games(): GameCategoryOrderType[] {
    return this._games
  }

  set games(value: GameCategoryOrderType[]) {
    this._games = value
  }

  @computed
  get selectedElement(): GameCategoryOrderType {
    return this._selectedElement
  }

  set selectedElement(value: GameCategoryOrderType) {
    this._selectedElement = value
  }

  @computed
  get platformIds(): any[] {
    return this._platformIds
  }
}

